<template>
    <div class="col-md-5ths p-2 align-middle">
        <div class="form-group container-folder" :class="{'btn-default': folder.selected}">
            <p class="folder-title m-2"><small @click.stop.prevent="showMenu($event, folder)">
                <i class="fa fa-bars text-gray"></i><i class="text-gray fa fa-caret-down"></i>
               </small>&nbsp; <i class="fa text-yellow fa-folder"></i>&nbsp;  <small class="text-gray">{{folder.title}}</small></p>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            folder: {}
        },
        data() {
            return {
                contextMenuIsVisible: false
            }
        },
        methods: {
            showMenu(event, folder) {
                this.$emit('clickOpen', event, folder);
            }
        }
    }
</script>
<style rel="stylesheet/scss" lang="scss">
    .container-folder {
        border: solid 1px silver;
        border-radius: 8px;
        cursor: pointer;
        margin-right: -10px;
    }

    .folder-title {
        margin-left: 10px;
        white-space: nowrap;
        overflow: hidden;
    }
</style>